/* eslint-disable no-unused-vars */
import Icon from "@mui/material/Icon";
import PropTypes from "prop-types";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function NotableInfo({ text }) {
  return (
    <MKBox
      display={"flex"}
      flexDirection={"row"}
      alignItems={"center"}
      // sx={{ bgcolor: "lightblue" }}
      width={"100%"}
    >
      <MKBox display="flex" pr={1}>
        <Icon fontSize="medium" color="info">
          info
        </Icon>
      </MKBox>
      <MKBox display="flex">
        <MKTypography variant="body2" color="info" fontWeight="bold">
          {text}
        </MKTypography>
      </MKBox>
    </MKBox>
  );
}
NotableInfo.propTypes = {
  text: PropTypes.string.isRequired,
};

export default NotableInfo;
